import { Link } from 'react-router-dom';
import { Button, Header, Icon, Segment } from 'semantic-ui-react';

const NotFound = () => {
  return (
    <Segment placeholder>
      <Header icon>
        <Icon name="search" />
        ページがみつかりませんでした
      </Header>
      <Segment.Inline>
        <Button as={Link} to="/" primary>
          トップページに戻る
        </Button>
      </Segment.Inline>
    </Segment>
  );
};

export default NotFound;
